<script setup>
import { ref, onMounted } from 'vue';
import ArgData from '@/views/components/ArgData.vue';
import GroupDevice from "@/views/components/GroupDevice.vue";
import {deviceDataList} from "@/api/dataCenter"
import {signData, deviceTsl} from "@/api/device";
import Hls from 'hls.js';

const deviceParams = ref({
  pageSize: 10,
  pageNo: 1
})

const tclPropertieList = ref(null)

const dataList = ref([])
// 获取设备数据列表
const getDeviceDataList = async (params) => {
  dataList.value = []
  try {
    const res = await deviceDataList(params);
    if (res?.data?.list) {
      // 遍历并同步处理每个 item
      for (const item of res.data.list) {
        console.log(' = item?.serial?.includes(\'SXT\')',item, '= serial',item?.serial, item?.serial?.includes('SXT'))
        // 判断是否为视频设备
        if(item?.serial?.includes('SXT')) {
          // 通过物模型获取视频地址
          let videoObj = await deviceTsl({deviceName: item.deviceName})
          console.log(' = 视频设备',videoObj)
          if(videoObj && videoObj.data && videoObj.data.propertie[0].elementData){
            videoObj.data.propertie[0].elementData = JSON.parse(videoObj.data.propertie[0].elementData)
            item.videoObj = videoObj.data.propertie[0].elementData
          }

          item.type = 2

        } else if (item?.lastData?.[0]) {
          // 通过物模型获取 属性单位
          let params = { deviceName: item.deviceName }
          const deviceTslRes = await deviceTsl(params);
          tclPropertieList.value = deviceTslRes.data.propertie;

          // 通过标识 把物模型单位匹配到lastData

          for (const key in item?.lastData?.[0]) {
            // console.log(' = key currentDeviceData' ,key, currentDeviceData.value[0][key]);
            tclPropertieList.value.forEach((it) => {

              if(key === it.identifier) {
                // console.log(' = 新数据', key)
                // newCurrentData.value[key] = currentDeviceData.value[0][key]
                item.lastData[0][key].unit = it.elementUnit
              }
            })
          }


          // 等待 signData 的请求完成后再继续
          const signRes = await signData(Object.keys(item.lastData[0]));
          item.type = 1
          item.signDataObj = signRes.data;
        }
      }
      // 更新 dataList 的值
      dataList.value = res.data.list;

    }
  } catch (error) {
    console.error('Error fetching device data list:', error);
  }
};

// 通过组下设备勾选获取数据
function deviceList(e){
  deviceParams.value.deviceNames = e.join(',')
  dataList.value = null
  getDeviceDataList(deviceParams.value)
}


onMounted(() => {
  getDeviceDataList({})

});
</script>

<template>
<div  class="py-4 container-fluid">
  <div class="row d-flex flex-row ">
    <div class="col-lg-9 col-12">

      <div class="card m-2" v-for="(item,index) in dataList" :key="index">
        <div v-if="item.type === 1">
          <div class="card-header d-flex">
            <h5 class="m-2">{{item.noteName || '--'}}</h5>
            <div class="m-2"> {{item.onlineState === 1 ? $t('home.onLine') : $t('home.offLine')}}</div>
          </div>

<!--          <div>{{item.lastData[0]}}</div>-->

          <div class="card-body d-flex align-items-center row" v-if="item && item.lastData && item.lastData[0]">
            <arg-data :deviceName="item.deviceName" :argList="item.lastData[0]" :argObj="item.signDataObj"></arg-data>
          </div>
          <div v-else class="card-body d-flex align-items-center row">
            <el-empty :description="$t('home.noData')" />
          </div>
        </div>
        <div v-if="item.type === 2">
          <div style="width: 100%; height: 500px;" class="iframe-container p-3 d-flex align-items-center justify-content-center" v-html="item.videoObj[0].desc"></div>
<!--          <video style="width: 600px; height: 300px;" :src="item?.videoObj[2].desc"></video>-->
        </div>
      </div>
    </div>

    <div class="col-lg-3 col-12 mt-2">
      <div class="card h-100">
        <div class="card-header">
          <h5>{{$t('home.deviceList')}}</h5>
        </div>
        <div class="card-body">
          <group-device @device-list="deviceList"></group-device>
        </div>
      </div>
    </div>

  </div>

</div>
</template>

<style lang="scss">

.video-item {
  height: 500px;
  background-color: #eeeeee;
}

.el-collapse-item {
  padding: 0 5px;
  background-color: #F7F8FC !important; /* 替换为你需要的颜色 */
  margin-top: 5px;
}

.el-collapse-item__header {
  background-color: #F7F8FC !important; /* 替换为你需要的颜色 */
}

.el-collapse {
  border: none;
}

.device-item {
  height: 50px;
}
.device-item:hover {
  background-color: #eeeeee;
}

.iframe-container iframe {
  width: 100%;
  height: 100%;
  border: none; /* 去掉边框 */
}
</style>
